import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { useDispatch } from '@cbridge-utils/react-redux';
import { TextFieldControl } from '@cbridge-tools/field';
import { FormDialog } from '@cbridge-tools/form';
import { IDialogProps } from '@cbridge-modules/dialog';
import { AlertSubscriptionAction } from '../../alertSubscription.action';
import { ISubscriptionEmail } from '../../alertSubscription.interface';
import { useAddEmailFormSchema } from './useAddEmailFormSchema';

export function AddEmailDialog({ open, onClose }: IDialogProps<{ }, string | null>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const schema = useAddEmailFormSchema();

  const handleCloseWithoutChange = useCallback(() => onClose(null), [onClose]);

  const handleSubmit = useCallback(
    async (data: ISubscriptionEmail) => {
      dispatch(AlertSubscriptionAction.addEmail.started(data));
      await onClose(data.email);
    },
    [dispatch, onClose],
  );

  const title = t('text:configPage.alertEmails.action.addRecipient');

  return (
    <FormDialog
      open={open}
      onClose={handleCloseWithoutChange}
      onSubmit={handleSubmit}
      title={title}
      schema={schema}
      isCreateMode={true}
    >
      <Grid container={true} rowSpacing={2} columnSpacing={2}>
        <Grid size={12}>
          <TextFieldControl<ISubscriptionEmail, 'email'>
            name={'email'}
            label={t('text:entity.user.email.label')}
            required={true}
          />
        </Grid>
      </Grid>
    </FormDialog>
  );
}
